import { useEffect } from "react";

const JARVIS_THEME_LINK_ID = "jarvis-theme-css";
const JARVIS_THEME_HREF = "/components/cockpit.css";

interface JarvisThemeLinkProps {
  enabled: boolean;
}

export function JarvisThemeLink({ enabled }: JarvisThemeLinkProps): null {
  useEffect(() => {
    if (typeof document === "undefined") return;

    const existing = document.getElementById(JARVIS_THEME_LINK_ID);

    if (enabled) {
      if (existing instanceof HTMLLinkElement) {
        if (existing.href !== JARVIS_THEME_HREF && existing.getAttribute("href") !== JARVIS_THEME_HREF) {
          existing.href = JARVIS_THEME_HREF;
        }
        return undefined;
      }

      const link = document.createElement("link");
      link.id = JARVIS_THEME_LINK_ID;
      link.rel = "stylesheet";
      link.href = JARVIS_THEME_HREF;
      document.head.appendChild(link);

      return () => {
        link.remove();
      };
    }

    if (existing) {
      existing.remove();
    }

    return undefined;
  }, [enabled]);

  return null;
}
